import { Component, EventEmitter, OnInit, Output, ViewChild, TemplateRef, OnDestroy } from '@angular/core';
import { AuthenticationService } from '@app/core/authentication/authentication.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
// import { NgbModal } from '@ng-bootstrap/ng-bootstrap/modal';

@Component({
  selector: 'app-oauth',
  standalone: false,
  templateUrl: './oauth.component.html',
  styleUrls: ['./oauth.component.scss']
})
export class OauthComponent implements OnInit, OnDestroy {
  sts: boolean = true;
  showOAuthContent: boolean = true;
  
  
  
  constructor(private readonly authenticationService: AuthenticationService, private readonly modalService: NgbModal) { }
  
  private popStateHandler = () => {
    this.authenticationService["_termsModalVisible$"].next(false);
  };

  ngOnInit() {
     window.addEventListener('popstate', this.popStateHandler);
      this.authenticationService.login();
  
      this.authenticationService.currentMessage.subscribe(message => {
        
        this.sts = message;
        if (this.sts === false) {
        }

      });

    // Hide OAuth content box when terms modal is displayed
    this.authenticationService.termsModalVisible$.subscribe(isVisible => {
      
      this.showOAuthContent = !isVisible;
    });
  }

  ngOnDestroy() {
    window.removeEventListener('popstate', this.popStateHandler);
  }
  
}
